import { HomeWrap } from "./HomeWrap";

export function HomeProblem() {
  return (
    <section className="pb-[88px]">
      <HomeWrap className="grid gap-[34px] border-t border-[#E2D5C0] pt-[52px] min-[900px]:grid-cols-[1.15fr_.85fr] min-[900px]:items-start min-[900px]:gap-16">
        <div>
          <h2 className="font-display text-[clamp(32px,4.2vw,46px)] font-semibold leading-[1.06] tracking-[-0.015em] text-[#3B2314]">
            Everyone says work friendly. Nobody means the same thing.
          </h2>
          <p className="mt-[22px] text-[17.5px] leading-[1.6] text-[#7B4F2E]">
            When someone calls a café work friendly, they're telling you their afternoon went well.
            Theirs was an hour with a coffee. Yours is four hours, a laptop and a dying battery.
          </p>
          <p className="my-[26px] border-l-2 border-[#C9A227] pl-5 font-display text-[clamp(23px,2.6vw,29px)] italic leading-[1.28] text-[#3B2314]">
            Same café. Same honest opinion. Completely different answer.
          </p>
        </div>
        <div>
          <p className="text-[17.5px] leading-[1.6] text-[#7B4F2E]">
            So we stopped asking whether people liked a place, and started measuring the same four
            things everywhere.
          </p>
          <p className="mt-[14px] text-[17.5px] font-semibold leading-[1.6] text-[#3B2314]">
            WiFi. Outlets. Seating. Parking.
          </p>
        </div>
      </HomeWrap>
    </section>
  );
}
